export class UserRole {
  public static DEVELOPER: string = 'ROLE_VISUAL7_DEVELOPER';
  public static SWAGGER_UI: string = 'ROLE_SWAGGER_UI';
  public static USER_SUPPORT: string = 'ROLE_USER_SUPPORT';
  public static PUNISHER: string = 'ROLE_PUNISHER';
  public static NEWS: string = 'ROLE_NEWS';
  public static AD_CAMPAIGNS: string = 'ROLE_ADCAMPAIGNS';
  public static STARLITE_SYMBOLICATOR: string = 'ROLE_STARLITE_SYMBOLICATOR';
  // Localizator dashboard roles
  public static LOCALIZATOR_VIEWER: string = 'ROLE_LOCALIZATOR_VIEWER';
  public static LOCALIZATOR_QA: string = 'ROLE_LOCALIZATOR_QA';
  public static LOCALIZATOR_EDITOR_PRODUCT: string = 'ROLE_LOCALIZATOR_EDITOR_PRODUCT';
  public static LOCALIZATOR_EDITOR_GAME_DEVELOPER: string = 'ROLE_LOCALIZATOR_EDITOR_GAME_DEVELOPER';
  public static LOCALIZATOR_EDITOR_GAME_WRITER: string = 'ROLE_LOCALIZATOR_EDITOR_GAME_WRITER';
  public static LOCALIZATOR_EDITOR_L10N_TEAM: string = 'ROLE_LOCALIZATOR_EDITOR_L10N_TEAM';
  public static LOCALIZATOR_ADMIN: string = 'ROLE_LOCALIZATOR_ADMIN';
  public static LOCALIZATOR_EDITORS: string[] = [
    UserRole.LOCALIZATOR_EDITOR_PRODUCT,
    UserRole.LOCALIZATOR_EDITOR_GAME_DEVELOPER,
    UserRole.LOCALIZATOR_EDITOR_GAME_WRITER,
    UserRole.LOCALIZATOR_EDITOR_L10N_TEAM,
    UserRole.LOCALIZATOR_ADMIN
  ];
  public static LOCALIZATOR_ALL_ROLES: string[] =
    UserRole.LOCALIZATOR_EDITORS.concat([UserRole.LOCALIZATOR_VIEWER, UserRole.LOCALIZATOR_QA]);

  // Gladiators
  public static GLADIATORS_RANKINGS: string = 'ROLE_GLADIATORS_RANKINGS_VIEWER';

  // New roles

  // O7Devices
  public static O7DEVICES_EDITOR: string = 'o7devices-editor';

  // Config7 roles
  public static CONFIG7_VIEWER: string = 'config7-viewer';

  // GDoc
  public static GDOC_VIEWER: string = 'gdoc-viewer';

  // Crosspromo DSP
  public static CROSSPROMO_DSP_EDITOR: string = 'crosspromo-dsp-editor';

  // AB tests
  public static AB_TESTS_VIEWER: string = 'ab-tests-viewer';

  // Placements
  public static PLACEMENTS_EDITOR: string = 'placements-editor';

  // Coupons
  public static COUPONS_EDITOR: string = 'coupons-editor';

  // Events Horizon
  public static EVENTS_HORIZON_EDITOR: string = 'events-horizon-editor';

  // Localizator V2
  public static LOCALIZATOR_V2_VIEWER: string = 'localizator-viewer';

  // AppRocket
  public static APPROCKET_BUILD_VIEWER: string = 'approcket-build-viewer';

  // Mediation
  public static MEDIATION_VIEWER: string = 'mediation-viewer';
  public static MEDIATION_EDITOR: string = 'mediation-editor';
}
